import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import patientDetailsAdapter from "@/redux/slice/auth/adapter/patientDetails";

const selectAuth = (state: RootState) => state?.auth;

const patientDetailsSelector = createDraftSafeSelector(selectAuth, (auth) => auth?.patientDetails);

// Export the customized selectors for patientDetails adapter using `getSelectors`
export const {
  selectAll: selectAllPatients,
  selectById: selectPatientById,
  selectIds: selectPatientIds,
} = patientDetailsAdapter.getSelectors(
  // Pass in a selector that returns the patientDetails field of auth slice of state
  patientDetailsSelector
);
